// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f8dbaa48fc658d121b28","303":"515b201ecaf53d7824d0","495":"9536653210bdc953d9f8"}[chunkId] + ".js";
};